import { getAxiosAPIInstance } from "./config";

const client = getAxiosAPIInstance();

export const getNotifications = async () => {
  try {
    const response = await client.get("/notifications");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const markAsRead = async (notificationId) => {
  const encodedId = encodeURIComponent(notificationId);

  try {
    const response = await client.patch(
      `/notifications/${encodedId}/read`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
